module.exports = __webpack_public_path__ + "static/media/code-icon.214527c8.svg";